export type OperationCategory = "calc" | "views" | "report";

export type OperationInfo = {
  id: string;
  title: string;
  description: string;
  required_columns: string[];
  category: OperationCategory;
  has_view_counting: boolean;
};

export type UserRole = "user" | "admin";

export type MeInfo = {
  tgid: number;
  username: string | null;
  first_name: string | null;
  last_name: string | null;
  role: UserRole;
  permissions: string[];
  is_admin: boolean;
};

export type UserInfo = {
  tgid: number;
  username: string | null;
  first_name: string | null;
  last_name: string | null;
  role: UserRole;
  permissions: string[];
};

export const REQUEST_FEATURE = "request";

export type AuthConfig = {
  login_enabled: boolean;
  client_id: string;
  login_script_url: string;
};

/** Результат, который SDK telegram-login.js передаёт в колбэк auth(). */
export type TelegramAuthResult = {
  id_token?: string;
  user?: unknown;
  error?: string;
};

export type AuthResult = {
  token: string;
  me: MeInfo;
};

export type VisualType = "сетка" | "карусель";

export type Contractor = {
  name: string;
  price_table_url: string;
};

export type ContractRequisite = {
  name: string;
  requisites: string;
};

export type DataSettings = {
  contractors: Contractor[];
  contracts: ContractRequisite[];
};

export type RequestConfig = {
  contractors: string[];
};

export type RequestBuild = {
  contractor: string;
  theme: string;
  links: string;
  visual_url: string;
  visual_type: VisualType;
  text: string;
};

export type RequestBuildResult = {
  text: string;
  total_sum: number;
  links_count: number;
  char_count: number;
  unmatched_links: string[];
};

export type JobOptions = {
  round_views: boolean;
  count_views: boolean;
  count_interactions: boolean;
  count_subscribers: boolean;
  count_text_length: boolean;
};

export const DEFAULT_JOB_OPTIONS: JobOptions = {
  round_views: true,
  count_views: true,
  count_interactions: true,
  count_subscribers: true,
  count_text_length: true,
};

export type JobStatus = "pending" | "running" | "done" | "failed";

export type JobError = {
  row_match: string;
  message: string;
};

export type JobInfo = {
  id: string;
  operation_id: string;
  table_url: string;
  status: JobStatus;
  processed: number;
  total: number;
  errors: JobError[];
  started_at: number;
  finished_at: number | null;
  fatal_error: string | null;
};
